export const PMCommissionCoefficient = 1.005;
